import Button from 'Components/Button';
import { useNavigate } from 'react-router-dom';

const ButtonBack = () => {
  const navigate = useNavigate();
  return <Button iconprefix={['fa', 'left-long']} onClick={() => navigate(-1)} />;
};

export default ButtonBack;
